var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "symptom-question-page",
    },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "step-label" }, [
          _vm._v(
            "Q" +
              _vm._s(_vm.currentIndex + 1) +
              "/" +
              _vm._s(_vm.questionSets.length)
          ),
        ]),
        _c("div", { staticClass: "divider" }),
        _c("div", { staticClass: "question-title" }, [
          _vm._v(" 请选择您的病症表现 "),
          _vm.currentSet
            ? _c("span", [_vm._v(" — " + _vm._s(_vm.currentSet.name))])
            : _vm._e(),
          _vm.diagInfo && _vm.diagInfo.chDiagName
            ? _c("span", { staticClass: "diag-name" }, [
                _vm._v(" — " + _vm._s(_vm.diagInfo.chDiagName)),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "options-grid" },
        [
          _vm._l(_vm.currentOptions, function (opt, idx) {
            return _c(
              "div",
              {
                key: idx,
                staticClass: "option-btn",
                class: { active: _vm.isSelected(opt) },
                on: {
                  click: function ($event) {
                    return _vm.toggleOption(opt)
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "dot",
                  class: { active: _vm.isSelected(opt) },
                }),
                _c("span", [_vm._v(_vm._s(opt))]),
              ]
            )
          }),
          _vm.currentOptions.length === 0 && !_vm.loading
            ? _c("div", { staticClass: "empty-tip" }, [
                _vm._v(" 暂无选项数据 "),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "footer-actions" }, [
        _c(
          "div",
          {
            staticClass: "action-btn btn-nav",
            class: { disabled: _vm.currentIndex === 0 },
            on: { click: _vm.prevPage },
          },
          [_vm._v(" 上一页 ")]
        ),
        _c(
          "div",
          {
            staticClass: "action-btn btn-nav",
            class: {
              disabled: _vm.currentIndex === _vm.questionSets.length - 1,
            },
            on: { click: _vm.nextPage },
          },
          [_vm._v(" 下一页 ")]
        ),
        _c(
          "div",
          { staticClass: "action-btn btn-back", on: { click: _vm.handleBack } },
          [_vm._v("返回")]
        ),
        _c(
          "div",
          {
            staticClass: "action-btn btn-confirm",
            on: { click: _vm.handleConfirm },
          },
          [_vm._v("确定")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }